import { Component, OnInit } from '@angular/core';
import { AuthenticationService } from '../../core/authentication/authentication.service'
import { AppMetadataHandler, AppOrganizationSettings } from '../../configs'
import { ThreadsService } from '../../core/utilities/threads.service'
import { ActivatedRoute } from '@angular/router';
import { NzNotificationService } from 'ng-zorro-antd/notification';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SessionTimeoutService } from 'app/BaseFramework/core/services/session/session-timeout.service';
import configjson from '../../../../configs/health-nbu-transaction.json'
import { environment } from 'environments/environment';
import { ApiRequestService } from 'app/BaseFramework/core';

export interface LoginContext {
  username: string;
  password: string;
  remember?: boolean;
}

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  constructor(
    public authenticationService: AuthenticationService,
    private notificationService: NzNotificationService,
    private activatedRoute: ActivatedRoute,
    public appMetadataHandler: AppMetadataHandler,
    private appOrganizationSettings: AppOrganizationSettings,
    private threadsService: ThreadsService,
    private http: HttpClient,
    public apiRequestService: ApiRequestService,
    public sessionTimeoutService:SessionTimeoutService
  ) {
    this.activatedRoute.queryParams.subscribe(params => {
      let error = params['error'];
      if (error) {
        this.notificationService.create('error', 'Error', error + "<br><b>Please reload the app.</b>");
      }
    });
  };

  organizationMetaData: any;
  oauthParams = {
    code: null,
    state: null,
    provider: null,
    applicationId: environment.applicationId,
    applicationSource: environment.applicationSource,
  };
  ngOnInit() {
    this.authenticationService.logout();
    this.organizationMetaData = this.appOrganizationSettings.getOrganizationMetaData();
    this.getConfigDataAndInitialize()
    this.threadsService.PRELOGINTHREAD().subscribe(o => {
      if (o['status'])
        this.threadsService._successThreadLog('Pre-Login Thread Successful');
      else
        this.threadsService._errorThreadLog('There is some problem in pre-login thread');
    })

    /* Prefetch icons hack. @thinkdj 31jul19 */
    setTimeout(() => { this.prefetch = true }, 500);
    if (localStorage.getItem('returnUrl') != null) {
      let tmpurl = (localStorage.getItem('returnUrl').split("/"));
      let provider = tmpurl[tmpurl.length - 1];
      this.oauthParams['provider'] = provider;
    }
    if (localStorage.getItem('state') != null) { this.oauthParams['state'] = (localStorage.getItem('state')); }
    if (localStorage.getItem('code') != null) { this.oauthParams['code'] = (localStorage.getItem('code')); }
    if (!environment.production) {
      // this.login(environment['loginContext'])
      //this.login({ username: "INT1", password: "admin" });
    }
  }

  loginContext: LoginContext = { username: "", password: "" };

  login(context: LoginContext) {
    this.authenticationService.fetchToken(context, this.appMetadataHandler.getEntryPoint());
  }

  prefetch: boolean = false;
  configPath = "/configs/health-nbu-transaction.json"
  configData: any
  getConfigDataAndInitialize() {
    this.configData = configjson;
    this.appMetadataHandler.setCurrency(this.configData.AppConstants.defaultCurrency)
  }

  /*Loading config file locally */
  public getJSON(): Observable<any> {
    return this.http.get(this.configPath);
  }

  elementResp(event){
     if(event.detail && event.detail.user && event.detail.responseCode !=='FAILURE' ){
      this.authenticationService.loginWithToken(event.detail.user,event.detail.responseCode, this.appMetadataHandler.getEntryPoint());
    }
}

}
